(function () {
  const CACHE_KEY = 'swatchCSS';
  const CACHE_VERSION_KEY = 'swatchCSS_v';
  const CACHE_TTL = 60 * 60 * 1000; // 1 hour
  const API_VERSION = '2024-07';
  const METAOBJECT_TYPE = 'custom_swatches';

  function getToken() {
    return (window.swatchConfig?.accessToken || window.theme?.settings?.accessToken || '').trim();
  }

  function injectCSS(css) {
    if (!css) return;
    let style = document.getElementById('swatch-loader-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'swatch-loader-styles';
      document.head.appendChild(style);
    }
    style.textContent = css;
  }

  function sanitizeName(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildCSS(swatches) {
    let rules = '';
    let vars = ':root{';

    for (const swatch of swatches) {
      const mainName = sanitizeName(swatch.name);
      const color = swatch.color || '';
      const imageUrl = swatch.image || '';
      const translateNames = swatch.translate_names || [];

      vars += '--swatch-color-' + mainName + ':' + color + ';';
      var bg = imageUrl
        ? 'url(' + imageUrl + ')'
        : 'linear-gradient(to right, ' + color + ', ' + color + ')';
      rules += '.filter-' + mainName + '{background-color:var(--swatch-color-' + mainName + ');--swatch-background:' + bg + ';}';

      if (imageUrl) {
        rules += '.filter-' + mainName + '{background-size:contain;background-image:url(' + imageUrl + ');}';
      }

      for (const alias of translateNames) {
        const aliasName = sanitizeName(alias);
        rules += '.filter-' + aliasName + '{background-color:var(--swatch-color-' + mainName + ');--swatch-background:' + bg + ';}';
        if (imageUrl) {
          rules += '.filter-' + aliasName + '{background-size:contain;background-image:url(' + imageUrl + ');}';
        }
      }
    }

    vars += '}';
    return rules + vars;
  }

  function getCached() {
    try {
      const timestamp = localStorage.getItem(CACHE_VERSION_KEY);
      if (timestamp && Date.now() - parseInt(timestamp, 10) < CACHE_TTL) {
        return localStorage.getItem(CACHE_KEY);
      }
    } catch (e) { /* localStorage unavailable */ }
    return null;
  }

  function setCache(css) {
    try {
      localStorage.setItem(CACHE_KEY, css);
      localStorage.setItem(CACHE_VERSION_KEY, String(Date.now()));
    } catch (e) { /* quota exceeded or unavailable */ }
  }

  function parseTranslateNamesValue(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (e) {
      console.error('Failed to parse translate names value:', e);
      return [];
    }
  }

  function parseSwatchFields(node) {
    const swatch = { name: '', color: '', image: '', translate_names: [] };
    let listAliasesPresent = false;
    let listAliases = [];
    let jsonAliases = [];
    for (const field of node.fields) {
      switch (field.key) {
        case 'name':
          swatch.name = field.value || '';
          break;
        case 'color':
          swatch.color = field.value || '';
          break;
        case 'image':
          swatch.image = field.reference?.image?.url
            ? field.reference.image.url + (field.reference.image.url.includes('?') ? '&' : '?') + 'width=72'
            : '';
          break;
        case 'translate_list':
          listAliasesPresent = true;
          listAliases = parseTranslateNamesValue(field.value);
          break;
        case 'translate_names':
          jsonAliases = parseTranslateNamesValue(field.value);
          break;
      }
    }
    swatch.translate_names = listAliasesPresent ? listAliases : jsonAliases;
    return swatch;
  }

  async function fetchAllSwatches() {
    const token = getToken();
    if (!token) return [];

    const swatches = [];
    let hasNextPage = true;
    let cursor = null;

    while (hasNextPage) {
      const afterClause = cursor ? ', after: "' + cursor + '"' : '';
      const query = `{
        metaobjects(type: "${METAOBJECT_TYPE}", first: 250${afterClause}) {
          pageInfo { hasNextPage endCursor }
          nodes {
            fields {
              key
              value
              reference {
                ... on MediaImage {
                  image { url }
                }
              }
            }
          }
        }
      }`;

      const res = await fetch('/api/' + API_VERSION + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query })
      });

      if (!res.ok) break;

      const json = await res.json();

      if (Array.isArray(json?.errors) && json.errors.length > 0) break;

      const data = json?.data?.metaobjects;
      if (!data) break;

      for (const node of data.nodes) {
        const swatch = parseSwatchFields(node);
        if (swatch.name) swatches.push(swatch);
      }

      hasNextPage = data.pageInfo.hasNextPage;
      cursor = data.pageInfo.endCursor;
    }

    return swatches;
  }

  const cached = getCached();
  if (cached) {
    injectCSS(cached);
    return;
  }

  fetchAllSwatches()
    .then(function (swatches) {
      if (swatches.length === 0) return;
      const css = buildCSS(swatches);
      injectCSS(css);
      setCache(css);
    })
    .catch(function () {});
})();
